import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

/**
 Formatted message creates a <span /> by default.
 <span /> is not a valid child of <select />.
 This is a version where FormattedMessage creates an <option />.
**/
const OptionFormattedMessage = ({ message, value }, rest) => (
  <FormattedMessage
    {...rest}
    {...message}
    children={( // eslint-disable-line
      (text) => <option value={value}>{text}</option>
    )}
  />
);

OptionFormattedMessage.propTypes = {
  message: PropTypes.object.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default OptionFormattedMessage;



// WEBPACK FOOTER //
// ./src/components/OptionFormattedMessage/index.js